<script lang="ts" setup>
import { $tm } from '@/locize';
import type { IImportStatus } from './IImportStatus';

const props = defineProps<{
    value: IImportStatus;
}>();
</script>

<template>
    <div
        v-if="value.Status != null"
        v-html="$tm(value.Status ?? '') + ' ' + ((value.Column ?? '') == '' ? '' : ` [${$tm(value.Column!)}]`)"
    ></div>
</template>
